import type { ReactNode } from 'react';
import type { Signal } from '../lib/types';
import { InfoPopover } from './InfoPopover';
import styles from './SignalCard.module.css';

interface Props {
  tone: 'bull' | 'bear';
  title: string;
  bullets: Signal[];
  tooltip?: ReactNode;
  className?: string;
}

export function SignalCard({ tone, title, bullets, tooltip, className }: Props) {
  return (
    <article
      className={[styles.card, tone === 'bull' ? styles.bull : styles.bear, className]
        .filter(Boolean)
        .join(' ')}
      aria-label={title}
    >
      <div className={styles.titleRow}>
        <h3 className={styles.title}>{title}</h3>
        {tooltip && <InfoPopover label={`About ${title.toLowerCase()}`} content={tooltip} />}
      </div>
      <ul className={styles.list}>
        {bullets.map((b, i) => (
          <li key={i} className={styles.item}>
            <span className={styles.marker} aria-hidden="true" />
            <span className={styles.body}>
              <span className={styles.text}>{b.text}</span>
              {b.paragraphRef && <span className={styles.ref}>{b.paragraphRef}</span>}
            </span>
          </li>
        ))}
      </ul>
    </article>
  );
}
